import { Route, Routes, Navigate } from "react-router-dom";
// App Routes
import appRoutes from "./app/app_routes";
import { AwaitDialogProvider } from "./app/components/status_dialog";

function App() {
  const configAppRoutes = appRoutes;

  const getAppRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
          title={route.name}
        />
      );
    });

  return (
    <div>
      <AwaitDialogProvider>
        <Routes>
          {getAppRoutes(configAppRoutes)}
          <Route path="*" element={<Navigate to="/error" />} />
        </Routes>
      </AwaitDialogProvider>
    </div>
  );
}

export default App;
